import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useColorScheme } from "@mui/joy/styles";
import { Toaster as Sonner, type ToasterProps } from "sonner";

// shadcn's stock version reads the theme from next-themes; here Joy owns the
// mode, and the rule matches ThemeSync's so a toast is never the one light
// thing on a dark page.
const Toaster = ({ ...props }: ToasterProps) => {
  const { mode } = useColorScheme();

  return (
    <Sonner
      theme={mode === "dark" ? "dark" : "light"}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4 text-destructive" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
